(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["customer-reviews"] && !Shopify.designMode) return;
  try {
    
  function initializeCustomerReviewCards(scope) {
    scope.querySelectorAll('.customer-reviews').forEach(function (section) {
      if (section.dataset.reviewsPaginationReady === 'true') return;
      section.dataset.reviewsPaginationReady = 'true';
      var cards = Array.from(section.querySelectorAll('[data-review-card]'));
      var button = section.querySelector('[data-reviews-more]');
      if (!button || cards.length <= 14) return;
      var visible = 14;
      cards.slice(visible).forEach(function (card) { card.hidden = true; });
      button.hidden = false;
      button.addEventListener('click', function () {
        var next = Math.min(visible + 14, cards.length);
        cards.slice(visible, next).forEach(function (card) { card.hidden = false; });
        visible = next;
        button.setAttribute('aria-expanded', 'true');
        if (visible >= cards.length) button.hidden = true;
      });
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initializeCustomerReviewCards(document); });
  } else {
    initializeCustomerReviewCards(document);
  }
  document.addEventListener('shopify:section:load', function (event) { initializeCustomerReviewCards(event.target); });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["frostface-quick-carousel"] && !Shopify.designMode) return;
  try {
    
  if (!window.__ffQuickCarouselBound) {
    window.__ffQuickCarouselBound = true;

    document.addEventListener('change', (event) => {
      const select = event.target.closest('.ff-quick__select');
      if (!select) return;

      const card = select.closest('.ff-quick__card');
      const option = select.options[select.selectedIndex];
      if (!card || !option) return;

      const price = Number.parseInt(option.dataset.priceCents || '0', 10);
      const compare = Number.parseInt(option.dataset.compareCents || '0', 10);
      const discount = compare > price ? Math.round(((compare - price) * 100) / compare) : 0;
      const priceNode = card.querySelector('[data-price]');
      const compareNode = card.querySelector('[data-compare]');
      const badge = card.querySelector('.ff-quick__badge');
      const image = card.querySelector('.ff-quick__image');

      if (priceNode) priceNode.textContent = option.dataset.price || '';
      if (compareNode) {
        compareNode.hidden = !discount;
        if (discount) compareNode.textContent = option.dataset.compare || '';
      }
      if (badge) {
        badge.hidden = !discount;
        const discountNode = badge.querySelector('[data-discount]');
        if (discountNode) discountNode.textContent = discount;
      }
      if (image && option.dataset.image) {
        image.src = option.dataset.image;
        image.removeAttribute('srcset');
        image.removeAttribute('sizes');
      }
    });

    document.addEventListener('submit', async (event) => {
      const form = event.target.closest('.ff-quick__form');
      if (!form) return;

      event.preventDefault();
      const section = form.closest('.ff-quick');
      const button = form.querySelector('.ff-quick__add');
      const status = form.querySelector('.ff-quick__status');
      const errorLabel = section ? section.dataset.statusError : '';
      if (!button || button.disabled) return;

      button.disabled = true;
      button.setAttribute('aria-busy', 'true');
      if (status) status.textContent = '';

      try {
        const cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
        const data = new FormData(form);
        if (cart && typeof cart.getSectionsToRender === 'function') {
          data.append('sections', [...new Set([...cart.getSectionsToRender().map((sectionToRender) => sectionToRender.id), 'cart-icon-bubble'])].join(','));
          data.append('sections_url', window.location.pathname);
        }

        const response = await fetch(form.action.replace(/\/$/, '') + '.js', {
          method: 'POST',
          body: data,
          headers: {
            Accept: 'application/json',
            'X-Requested-With': 'XMLHttpRequest'
          }
        });
        const result = await response.json();
        if (!response.ok || result.status) throw new Error(result.description || result.message || errorLabel);

        if (status) status.textContent = section ? section.dataset.statusAdded : '';
        if (cart && result.sections && typeof cart.renderContents === 'function') {
          cart.classList.remove('is-empty');
          cart.renderContents(result);
        } else {
          const cartUrl = window.routes && window.routes.cart_url ? window.routes.cart_url : '/cart';
          window.location.href = cartUrl;
          return;
        }

        if (result.sections && result.sections['cart-icon-bubble']) {
          const freshIcon = new DOMParser().parseFromString(result.sections['cart-icon-bubble'], 'text/html').querySelector('#cart-icon-bubble');
          const currentIcon = document.querySelector('#cart-icon-bubble');
          if (freshIcon && currentIcon) currentIcon.innerHTML = freshIcon.innerHTML;
        }

        try {
          const cartUrl = window.routes && window.routes.cart_url ? window.routes.cart_url : '/cart';
          const countResponse = await fetch(cartUrl.replace(/\/$/, '') + '.js', { headers: { Accept: 'application/json' } });
          if (countResponse.ok) {
            const count = (await countResponse.json()).item_count;
            const icon = document.querySelector('#cart-icon-bubble');
            if (icon) {
              let bubble = icon.querySelector('.cart-count-bubble');
              if (count > 0) {
                if (!bubble) {
                  bubble = document.createElement('div');
                  bubble.className = 'cart-count-bubble';
                  icon.appendChild(bubble);
                }
                bubble.innerHTML = '<span aria-hidden="true">' + count + '</span><span class="visually-hidden">' + count + ' items</span>';
              } else if (bubble) {
                bubble.remove();
              }
            }
          }
        } catch (_) {}
      } catch (error) {
        if (status) status.textContent = error.message || errorLabel;
      } finally {
        button.disabled = false;
        button.removeAttribute('aria-busy');
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
